import { useCallback, useMemo } from "react";
import { useEntitlements } from "@/hooks/useEntitlements";
import type { ModuleKey } from "@/modules/registry";

export function useModuleAccess() {
  const { data, isLoading } = useEntitlements();
  const active = useMemo(() => new Set(data?.activeModules ?? []), [data]);

  const has = useCallback(
    (module: ModuleKey | ModuleKey[]) => {
      const list = Array.isArray(module) ? module : [module];
      return list.some((key) => key === "core" || active.has(key));
    },
    [active],
  );

  return { has, isLoading };
}
